import React from "react";

const PatientDetailUrlContext = React.createContext({
  param: {},
  updateParam: () => {}
});

export default PatientDetailUrlContext;
